export default [
  {
    path: '/history',
    component: () => import('@/views/history/historyList.vue')
  },
  {
    path: '/history/:userNo',
    component: () => import('@/views/history/historyDetail.vue')
  }
];
